import React from "react";

const footerStyle = {
    backgroundColor: "#FFFFFF",
    color: "black",
    textAlign: "center",
    padding: "10px",
    position: "fixed",
    bottom: 0,
    width: "100%"
};

function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <footer style={footerStyle}>
            <h3>&copy; {currentYear}, Computers for Students. All rights reserved.</h3>
        </footer>
    );
}

export default Footer;
